import React from "react";
import ReactDOM from "react-dom";
import App from "./Components/App";
import * as firebase from "firebase";
import "./styles/styles.css";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "./apollo";
import { HelmetProvider } from "react-helmet-async";

if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_FIREBASE_API
) {
  let firebaseApiString = process.env.REACT_APP_FIREBASE_API.replace(
    "{",
    ""
  ).replace("}", "");
  let firebaseApis = firebaseApiString.split(",");
  let firebaseApi = {};
  firebaseApis.map((ap) => {
    let keysValues = ap.replace(`"`, "").replace(`"`, "").split(": ");
    keysValues[0] = keysValues[0].replace(/ /g, "");
    return (firebaseApi[keysValues[0]] = keysValues[1]);
  });
  firebase.initializeApp(firebaseApi);
} else if (
  process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_PRODUCTION_FIREBASE_API
) {
  let firebaseApiString = process.env.REACT_APP_PRODUCTION_FIREBASE_API.replace(
    "{",
    ""
  ).replace("}", "");

  let firebaseApis = firebaseApiString.split(",");
  let firebaseApi = {};
  firebaseApis.map((ap) => {
    let keysValues = ap.replace(`"`, "").replace(`"`, "").split(": ");
    keysValues[0] = keysValues[0].replace(/ /g, "");
    return (firebaseApi[keysValues[0]] = keysValues[1]);
  });
  firebase.initializeApp(firebaseApi);
}

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <ApolloProvider client={apolloClient}>
        <App />
      </ApolloProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
